import { Button, Checkbox } from 'antd';
import { FormItem } from 'react-antd-formutil';
import { CardButtonWrap } from 'components/Card';

interface LogoffBottomProps {
    errorMsg: string;
    checkBoxLabel: string;
    btnDisabled: boolean;
}

const LogoffBottom: React.FC<LogoffBottomProps> = ({ errorMsg, checkBoxLabel, btnDisabled }) => {
    return (
        <div className="logoff-bottom-container">
            <FormItem
                name="close_confirm"
                required
                validMessage={{
                    required: errorMsg
                }}>
                <Checkbox>{checkBoxLabel}</Checkbox>
            </FormItem>
            <CardButtonWrap>
                <Button disabled={btnDisabled} className="mt-3" size="large" type="primary" htmlType="submit">
                    {__('Next step')}
                </Button>
            </CardButtonWrap>
        </div>
    );
};

export default LogoffBottom;
